export default __webpack_public_path__ + "static/media/img1.419a84a8.PNG";